/**
 * Labels for "my registrations" when a parent account includes linked child users.
 * Rows include participant_name and participant_user_id from GET /getMyEvents.
 */

/** Server EventParticipant.attendance values → short UI label for badges and summaries. */
export function formatMyRegistrationStatusLabel(attendanceRaw) {
  const key = (attendanceRaw != null ? String(attendanceRaw) : "").trim();
  if (!key) return "Registered";
  const map = {
    Registered: "Registered",
    Waitlisted: "Waitlisted",
    Attended: "Attended",
    "Walk-In": "Walk-in",
    Cancelled: "Cancelled",
    "No-Show": "No-Show",
  };
  if (map[key]) return map[key];
  const normHyphen = key.replace(/_/g, "-").replace(/\s+/g, "-").toLowerCase();
  if (normHyphen === "no-show" || normHyphen === "noshow") return "No-Show";
  const norm = key.replace(/-/g, " ").replace(/\s+/g, " ").trim();
  if (/^no show$/i.test(norm)) return "No-Show";
  return key.replace(/-/g, " ");
}

/** EventParticipant.attendance → staff-facing label (roster export, print, reports). */
export function formatEventAttendanceStatusLabel(attendanceRaw) {
  const key = (attendanceRaw != null ? String(attendanceRaw) : "").trim();
  if (!key) return "Registered";
  const map = {
    Registered: "Registered",
    Waitlisted: "Waitlisted",
    Attended: "Checked In",
    "Walk-In": "Walk-In",
    Cancelled: "Cancelled",
    "No-Show": "No-Show",
  };
  if (map[key]) return map[key];
  return formatMyRegistrationStatusLabel(attendanceRaw);
}

/** Child name for hero cards when the registration is for a linked child, not the signed-in user. */
export function getRegisteredEventParticipantChildLabel(ev, loggedInUserId) {
  const name = (ev && ev.participant_name ? String(ev.participant_name) : "").trim();
  if (!name) return "";
  const pid = ev.participant_user_id != null ? String(ev.participant_user_id) : "";
  const selfId = loggedInUserId != null ? String(loggedInUserId) : "";
  if (pid && selfId && pid !== selfId) return name;
  return "";
}

/** My Registered Events table/card: "You" for the signed-in user's own row, else participant display name. */
export function getMyEventsParticipantDisplay(ev, loggedInUserId) {
  const selfId = loggedInUserId != null ? String(loggedInUserId) : "";
  const pid = ev && ev.participant_user_id != null ? String(ev.participant_user_id) : "";
  if (pid && selfId && pid === selfId) return "You";
  const name = (ev && ev.participant_name ? String(ev.participant_name) : "").trim();
  return name || "—";
}
